/**
 * One part of the BOM item — the item under one parent — with every stage of the
 * dictionary in plant order. parentBomItemId null is the top-level part (the item
 * ordered as a root). Parts nobody said anything about are not listed — except on a
 * Purchased item, which lists every part it was ordered under (0115).
 */
export interface BomItemStagesDto {
  parentBomItemId: number | null;
  parentName: string | null;
  stages: StageDto[];
}

/**
 * fact null: nothing was said at the stage. skippedByDefault: nothing was said either,
 * but the item is Purchased, so the next order skips the stage (0115). factAt and the
 * order are where the latest fact was recorded — null without one.
 */
export interface StageDto {
  operationTypeId: number;
  name: string;
  fact: StageFact | null;
  factAt: string | null;
  orderId: number | null;
  orderNumber: string | null;
}

export enum StageFact {
  reported,
  skipped,
  restored,
  skippedByDefault
}
